import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableRow,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getSalaryById } from '../../api/salary-managemet';
import { useSelector } from 'react-redux';
import { errorMessages, formatterCurrency } from '../../utils/methods';
import useUserAuth from '../../utils/useUserAuth';

const PayrollDetails = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const canSalaryCreate = useUserAuth('EMPLOYEE_SALARY_CREATE');
  const { id } = useParams();
  const { user } = useSelector(state => state.user);
  const [salaryDetail, setSalaryDetail] = useState([]);
  const [name, setName] = useState('');
  const navigate = useNavigate();
  function createData(name, calories) {
    return { name, calories };
  }

  const getSalary = async () => {
    if (id) {
      const salary = await getSalaryById(id, user.token);
      setSalaryDetail(salary);
      setName(salary[0]?.name);
    }
  };

  // useEffect(() => {
  //   getSalary();
  // }, []);
  useEffect(() => {
    if (id) {
      getSalary();
    }
  }, [id]);

  return (
    <Box
      component={Paper}
      elevation={2}
      style={{
        background: '#fff',
        borderRadius: '5px',
        padding: '40px',
        width: '1080px',
      }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex' }}>
          <Link
            style={{
              textDecoration: 'none',
              color: '#3a3a3a',
              display: 'flex',
            }}
            to="/salary">
            <svg id="뒤로가기" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path id="Path_6534" data-name="Path 6534" d="M0,0H24V24H0Z" fill="none" />
              <circle
                id="Ellipse_96"
                data-name="Ellipse 96"
                cx="11"
                cy="11"
                r="11"
                transform="translate(1 1)"
                fill="#3a3a3a"
              />
              <path
                id="Path_6535"
                data-name="Path 6535"
                d="M6.393,8.579H14V9.865H6.393l3.352,3.448-.884.909L4,9.222l4.861-5,.884.909Z"
                transform="translate(3 2.778)"
                fill="#fff"
              />
            </svg>
            <Typography sx={{ fontSize: '18px', ml: '8px', fontWeight: '550' }}>{t('Salary Details')}</Typography>
          </Link>
        </Box>
        <Link
          style={{
            color: theme.palette.primary.main,
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 550,
          }}
          to="/salary">
          {t('List')}
        </Link>
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '22px' }}>
        <Typography sx={{ fontSize: '22px', fontWeight: 'bold' }}>{name || ''}</Typography>
        {canSalaryCreate && (
          <Button
            component={Link}
            to={`/salary/create?id=${id}&name=${name || ''}`}
            sx={{
              width: '122px',
              height: '36px',
              borderRadius: '12px',
              '&:hover': { background: '#0F7F85', color: '#fff' },
            }}
            variant="outlined">
            {t('Create')}
          </Button>
        )}
      </Box>

      {salaryDetail.map((row, index) => (
        <>
          {index === 0 ? (
            <Typography sx={{ mt: '30px', mb: '10px', fontSize: '16px', fontWeight: 500 }}>
              {t('Salary Breakdown')}
            </Typography>
          ) : (
            <Typography sx={{ mt: '30px', mb: '10px', fontSize: '16px', fontWeight: 500 }}>
              {t('Previous Salary Breakdown')}
            </Typography>
          )}

          <TableContainer sx={{ border: '1px solid #ddd', mb: '20px' }} key={index}>
            <Table>
              <TableBody>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('Basic Pay')}
                  </TableCell>

                  <TableCell align="center">{formatterCurrency(row.baseSalary)}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('Commission')}
                  </TableCell>

                  <TableCell align="center">{row.commission}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('Group Pay')}
                  </TableCell>

                  <TableCell align="center">{formatterCurrency(row.groupLessonAllowance)}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('1-on-1 Pay')}
                  </TableCell>

                  <TableCell align="center">{formatterCurrency(row.privateLessonAllowance)}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('Pay Period Begin')}
                  </TableCell>

                  <TableCell align="center">{t(row.startDate)}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '40px' }} key={row.id}>
                  <TableCell
                    align="center"
                    component="th"
                    scope="column"
                    sx={{
                      '.css-1yhpg23-MuiTableCell-root': { padding: '5px' },
                      width: '180px',
                      fontWeight: 600,
                      background: '#FAFBFC',
                    }}>
                    {t('Pay Period End')}
                  </TableCell>

                  <TableCell align="center">{t(row.endDate)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant="contained"
            sx={{
              width: '62px',
              height: '36px',
              borderRadius: '12px',
              backgroundColor: '#707070',
              '&:hover': { backgroundColor: '#707070' },
              mt: '10px',
              mb: '30px',
              ml: '938px',
            }}
            disabled={index !== 0}
            onClick={() => {
              navigate(`/salary/create?id=${id}&salaryId=${row.salaryId}`);
            }}>
            {t('EDIT')}
          </Button>
        </>
      ))}

      <hr style={{ border: '1px solid #e1e1e1' }} />
    </Box>
  );
};

export default PayrollDetails;
